import baseUrl from './baseUrl';

const URL_GET_UNIDADES = `${baseUrl}/unit`;

const getUnidades = async modulo => {
  try {
    const data = await fetch(`${URL_GET_UNIDADES}?modulo=${modulo}`, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!data.ok) {
      throw new Error('Ocorreu um erro inesperado');
    }

    const response = await data.json();

    if (Array.isArray(response)) {
      return [...response].sort((a, b) => a.unidade.localeCompare(b.unidade, 'pt-BR'));
    }

    return response;
  } catch (error) {
    console.log(error);
  }
};

export default getUnidades;
